import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import {Image} from 'components/atoms';
import {SectionHeader} from 'components/molecules';

const useStyles = makeStyles(_theme => ({
  logoImg: {
    maxWidth: 120,
  },
}));

const Partners = props => {
  const {data, className, ...rest} = props;
  const classes = useStyles();

  return (
    <div className={className} {...rest}>
      <Grid container spacing={5}>
        <Grid container item justify="space-between" alignItems="center" data-aos="fade-up">
          <SectionHeader
            title={
              <span>Top tech employers value a Make School education. Our alumni work at:</span>
            }
            align="center"
            disableGutter
            titleVariant="h5"
          />
        </Grid>
        <Grid container item justify="space-between" alignItems="center" data-aos="fade-up">
          {data.map(partner => (
            <Grid
              item
              container
              justify="center"
              alignItems="center"
              xs={6}
              sm={2}
              key={partner.name}
            >
              <Image
                src={partner.logo}
                alt={partner.name}
                className={classes.logoImg}
                lazy={false}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  );
};

Partners.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
    })
  ).isRequired,
};

export default Partners;
